<template lang="pug">
v-list-item.px-0(@click="open")
  v-layout.mx-4(:class="item.read ? 'read-icon' : 'normal-icon'")
    CashIcon.ma-auto(v-if="item.type == 'transaction_paid'" size="24" :style="{ 'color': item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].info400 }")
    eva-icon.ma-auto(v-else-if="item.type == 'lead_created'" name="clipboard-outline" width="24" height="24" :fill="item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].info400")
    .yezza.ma-auto(v-else)
      v-img(v-if="item.read" :src="require('@/assets/images/icon_notification_yezza_read.svg')" width="16")
      v-img(v-else :src="require('@/assets/images/icon_notification_yezza_normal.svg')" width="16")
  v-list-item-content(v-if="item.type == 'default'")
    v-list-item-subtitle.s1.mr-3(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic800 }" v-html="item.title")
    v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }") {{ item.created | convertToHumanizeTime }}
  v-list-item-content(v-else)
    v-list-item-title.s1.mr-3(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic800 }" v-html="item.title") {{ item.title }}
    v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }" v-html="item.body")
    v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }") {{ item.created | convertToHumanizeTime }}
  v-list-item-action(v-if="!item.read || item.type !== 'default'")
    v-menu(bottom :offset-x='false' :offset-y='true')
      template(v-slot:activator='{ on }')
        v-btn.elevation-0.pa-0.mt-3.mr-3(text color="transparent" min-width="auto" :ripple="false" x-small light v-on='on')
          eva-icon(name="more-vertical" :fill=" item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500" height="25" width="25" )
      v-list.pa-0
        v-list-item.border-bottom(v-if="!item.read" @click="$emit('onMarkRead', item.id)")
          v-list-item-content
            v-list-item-title.s2.basic800--text Mark Read
        v-list-item.border-bottom(v-if="item.type !== 'default'" @click="$emit('onDelete', item.id)")
          v-list-item-content
            v-list-item-title.s2.basic800--text Delete
</template>

<script>
import queryString from 'query-string'

// eslint-disable-next-line no-unused-vars
window.showSubscribeModal = () => {
  window.$store.commit('ui/setShowSubscribeModal', true)
  window.$router.push('/admin/dashboard')
}
window.toCreditHistory = (ref) => {
  if (ref) {
    window.$router.push(`/admin/billing/bills?ref=${ref}#creditHistory`)
  } else {
    window.$router.push(`/admin/billing/bills?#creditHistory`)
  }
}
window.toOrders = (leadRid) => {
  window.$router.push(`/admin/orders-new?order=${leadRid}`)
}

export default {
  name: 'NotificationItem',
  props: ['item'],
  data: () => ({
  }),
  methods: {
    getIconName (item) {
      if (item.type === 'transaction_paid') {
        return true
      }
      return 'clipboard-outline'
    },
    open () {
      this.$emit('onMarkRead', this.item.id)
      if (this.item.type === 'default') {
        const query = queryString.parse(this.item.url.split('?')[1])
        this.$router.replace({ query })
        this.$emit('viewDetails', this.item)
      } else if (this.item.in_app) {
        let url = this.item.url
        if (url.includes(process.env.VUE_APP_BASE_DOMAIN)) {
          url = url.split(process.env.VUE_APP_BASE_DOMAIN)[1]
        }
        this.$router.push(url)
      } else {
        window.open(this.item.url, '_blank');
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.read-icon {
  height: 44px;
  max-width: 44px;
  min-width: 44px;
  border: 2px solid var(--v-textColorDisabled);
  border-radius:  22px;
}

.normal-icon {
  height: 44px;
  max-width: 44px;
  min-width: 44px;
  border: 2px solid var(--v-info400);
  border-radius:  22px;
}

</style>